import type { InfluencerCampaignFilter } from "@/marketing/models/influencerCampaign";

export const INFLUENCER_CAMPAIGN_KEYS = {
  all: ["influencerCampaigns"] as const,
  lists: () => [...INFLUENCER_CAMPAIGN_KEYS.all, "list"] as const,
  list: (filter: InfluencerCampaignFilter) =>
    [...INFLUENCER_CAMPAIGN_KEYS.lists(), filter] as const,
  // Under lists() so any campaign-list invalidation also refreshes the tracker.
  tracker: () => [...INFLUENCER_CAMPAIGN_KEYS.lists(), "tracker"] as const,
  details: () => [...INFLUENCER_CAMPAIGN_KEYS.all, "detail"] as const,
  detail: (campaignId: string) =>
    [...INFLUENCER_CAMPAIGN_KEYS.details(), campaignId] as const,
};
